import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import "../../css/reports.css";
import { useLocation, useNavigate } from "react-router-dom";
import TokenService from "../../service/TokenService";
import SriyanshCardHeader from "../../components/CardHeader";
import apiClient from "../../BaseUrl/apiClient";
import dayjs from "dayjs";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import EncryptService from "../../service/EncryptionService";
import POReports from "../../POReports";
import CustomTextField from "../../CustomComponant/CustomTextField ";
function POdpUpdate() {
  const handleClose = () => {
    // navigate("../", { replace: true });
    navigate(-1);
  };
  const [minCalDate, setMinCalDate] = useState(dayjs());
  const [minPOCalDate, setMinPOCalDate] = useState(dayjs());
  const navigate = useNavigate();
  const { state } = useLocation();
  let indentId = state.po_id;

  const [errors, setErrors] = useState({});
  const [dpDate, setdpDate] = useState(dayjs());
  const [maDate, setmaDate] = useState(dayjs());
  const [maNumber, setmaNumber] = useState("");

  //  </div>
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  //const uname = sessionStorage.getItem("token");

  const getdata = async (e) => {

   if (!indentId || indentId.trim() === "") return;


    try {
      const response1 = await apiClient.post("/podetails", {
        uname: uname,
        indentNumber: String(indentId),
      });

    // console.log(response1.data.data[0]);
 
      const minValueDate =
        "'" + dayjs(response1.data.data[0].DPDate).format("YYYY-MM-DD") + "'";

      setMinCalDate(dayjs(minValueDate));

      const minPOValueDate =
        "'" + dayjs(response1.data.data[0].podate).format("YYYY-MM-DD") + "'";

      setMinPOCalDate(dayjs(minPOValueDate));

///console.log("DP Date is " + response1.data.data[0].DPDate);
   //   console.log ("po date is " + response1.data.data[0].podate)
     
    } catch (error) {
     
    }
  };

  useEffect(() => {
    getdata();
  }, [indentId]);

  const UpdateNewData = async (e) => {
    e.preventDefault();

    let formErrors = {};
    if (!maNumber || maNumber === "") {
      //  alert("MA Number Should not be Blank");
      formErrors.Errmanumber = "MA Number should Not be Blank";
    }

    //console.log(maNumber)

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const dpdt = new Date(dpDate);
      // const oldDate=new Date(olddpDate)
      const DP_date =
        dpdt.getFullYear() +
        "/" +
        parseInt(dpdt.getMonth() + 1) +
        "/" +
        dpdt.getDate();
      // alert("Update DP Date will work sholtly as " + (dpdt) + " OLD Date" +(oldDate) )

      const madt = new Date(maDate);
      // const oldDate=new Date(olddpDate)
      const MA_date =
        madt.getFullYear() +
        "/" +
        parseInt(madt.getMonth() + 1) +
        "/" +
        madt.getDate();

      const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
console.log("Sending dpdateupdate:", {
  vponumber: indentId.toString(),
  vuname: uname,  
})
      try {
        const response11 = apiClient.post("/dpdateupdate", {
          vponumber: indentId.toString(),
          vuname: uname,
          newdpdate: DP_date,
          maNumber,
          maDate: MA_date,
          ip,
        });
        if (response11) {
          // alert(response11);
          navigate(-1);
          // console.log(response11.data);
        } else {
          // Throw an error if no data is found
        }
      } catch (error) {
        alert(error.code);
      }
    }
  };
  return (
    <>
      {/* <SriyanshCardHeader Title="Reports" /> */}
      <Card className="Formcard">
        <div className="input-groupHeading">
          Reports - Modify DP Date

        </div>


        <CardContent>
          <POReports />

          <>
            <div className="container">
              <div className="input-group mt-2">
                <CustomTextField
                  label="Modify Advice Number"
                  value={maNumber ?? ""}
                  onChange={(e) => {
                    setmaNumber(e.target.value);
                  }}
                  placeholder="Modify Advice Number"
                  maxLength={100} // Set the maximum length
                  error={!!errors.Errmanumber}
                  helperText={errors.Errmanumber}
                />
              </div>

              <div className="input-group">
                <DatePickerComponent
                  label="Modify Advice  Date"
                  id="receiveddate"
                  value={maDate ?? dayjs(Date)}
                  onChange={setmaDate}
                  maxDate={dayjs()} //{dpDate ? dayjs.min(today, dpDate) : today}
                  minDate={minPOCalDate}
                />
              </div>
            </div>
            <div className="container">
              <div className="input-group">
                <DatePickerComponent
                  label="New DP Date"
                  id="dpdate"
                  value={dpDate || dayjs(Date)}
                  onChange={setdpDate}
                  minDate={minCalDate}
                // maxDate={dayjs(Date)}
                />
              </div>
              <div className="input-group" />

              <div className="input-group">
                <button
                  className="button button1"
                  type="button" // Updated type attribute to "button"
                  onClick={UpdateNewData}
                  //onClick={() => alert("Please Call to Admin")}
                  title="Click for Update Date"
                >
                  Update New DP Date
                </button>
                <button
                  className="button button1"
                  type="button" // Updated type attribute to "button"
                  onClick={handleClose}
                  title="Click for Back"
                  style={{ backgroundColor: "red", color: "white" }}
                >
                  Close
                </button>
              </div>
            </div>
          </>
        </CardContent>
      </Card>
    </>
  );
}

export default POdpUpdate;
